import { paymentMethods } from '@/helpers/enums';
import * as types from '../mutation-types'

export default {
    namespaced: true,
    state:{
        // summary: [],
        transactions: [],
        transactionsStatement: [],
        underLimitMaterials: []
    },

    actions:{
        fetchAll({ commit }, { queryType }){
            return window.axios.get('/materialtransactions/transactionsquery', {
                params:{
                    queryType
                    /*
                        queryType = 0 => Supervisors
                        queryType = 1 => MedicalReps
                    */
                }
            })
            .then((response) => {
                commit(types.STORE_TRANSACTINOS, response.data);
                return response.data;
            })
        },

        fetchByFilter({ commit }, { queryType, employeeId, materialId, materialFormId, fromDate, ToDate, page, perPage }){
            return window.axios.get('/materialtransactions/transactionsquery', {
                params:{
                    queryType,
                    /*
                        queryType = 0 => Supervisors
                        queryType = 1 => MedicalReps
                    */
                   employeeId,
                   materialId,
                   materialFormId,
                   fromDate,
                   ToDate,
                   page,
                   perPage
                }
            })
            .then((response) => {
                return {
                    data: response.data,
                    total: parseInt(response.headers["x-pagination-total-count"])
                };
            })
        },

        // fetchSelfSummary({ commit }, { withPrices }){
        //     return window.axios.get('/materialtransactions/selftransactionssummary', { params: { withPrices } })
        //     .then((response) => {
        //         commit(types.STORE_SUMMARY, response.data)
        //     });
        // },

        fetchMaterialReceiptsSummary({ commit }, { employeeId, fromDate, toDate }){
            return window.axios.get(`/materialtransactions/${employeeId}/MarketingTransactionsQuery`, {
                params: { fromDate, toDate }
            }).then((response) => {
                return response.data
            });
        },

        fetchRemaining({ commit }, { id }){
            return window.axios.get(`/materialtransactions/${id}/TransactionsSummary`).then((response) => {
                return response.data;
            });
        },

        restore({ commit }, { employeeId }){
            return window.axios.post('/materialtransactions/deliverBack', { employeeId });
        },

        create({ commit }, samples){
            return window.axios.post('/materialtransactions/deliver', samples);
        },

        update({ commit }, { id, newSampleData }){
            return window.axios.put(`/materialtransactions/${id}`, newSampleData);
        },

        delete({ commit }, { id }){
            return window.axios.delete(`/materialtransactions/${id}`);
        },

        singleTransaction ({ commit }, { materialId, accountId, out, inAmount, notes, sellPrice, payment, date, state, freeSample, priceDiscount }) {
            return window.axios.post('/materialtransactions/singleTransaction', { 
                materialId, 
                accountId, 
                out, 
                in: inAmount, 
                notes,
                sellPrice, 
                payment, 
                // new
                date,
                state,
                freeSample,
                priceDiscount
            }).then(({ data }) => {
                return data
            })
        },

        // fetchStatement({ commit }, { MaterialId, FromDate, ToDate, AccountId, PerPage, Page, WithVisitTransaction, type, Date, SelectInAmount, SelectOutAmount, entity, regionIds }) {
        //     return window.axios.get(`/materialtransactions/statement`, { 
        //         params: { MaterialId, FromDate, ToDate, AccountId, PerPage, Page, WithVisitTransaction, type, Date, SelectInAmount, SelectOutAmount, entity, regionIds }
        //     }).then((response) => {
        //         return {
        //             data: response.data,
        //             total: parseInt(response.headers['x-pagination-total-count'])
        //         }
        //     })
        // },
        fetchStatement({ commit }, { MaterialId, FromDate, ToDate, AccountId, PerPage, Page, WithVisitTransaction, type, Date, SelectInAmount, SelectOutAmount, isInput, entity, regionIds, entityTypeId }) {
            var urlSearchParams = new URLSearchParams();
            var params = { MaterialId, FromDate, ToDate, AccountId, PerPage, Page, WithVisitTransaction, type, Date, SelectInAmount, SelectOutAmount, entity, isInput, entityTypeId };
            
            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) {
                    urlSearchParams.append(param, params[param]);
                } 
            })

            regionIds.forEach(id => {
                urlSearchParams.append("regionIds", id);
            })
            return window.axios.get('/materialtransactions/statementWithEntityType', {
                params: urlSearchParams
            })
            .then((response) => {
                return {
                    data: response.data,
                    total: parseInt(response.headers['x-pagination-total-count'])
                };
            })
        },

        fetchTransactionsSummary({ commit }, { id }) {
            return window.axios.get(`materialTransactions/${id}/TransactionsSummary`).then(({ data }) => {
                return data
            })
        },

        fetchTransactionsStatement({ commit }, { materialId, accountId, cityId }) {
            const endpoint = accountId ? `account/${accountId}` : 'filter';
            const params = accountId ? { materialId } : { cityId, materialId };

            return window.axios.get(`materialTransactions/statistics/${endpoint}`, { params })
                .then(({ data }) => {
                    commit(types.STORE_TRANSACTIONS_STATEMENT, data);
                    return data;
                })
        },

        createDeliverAndReceive({ commit }, { materials }) {
            return window.axios.post('materialTransactions/DeliverAndReceive', materials).then(({ data }) => {
                return data
            })
        },

        // get under limit from material
        fetchUnderLimitMaterial ({ commit }) {
            return window.axios.get('/MaterialTransactions/UnderLimit/Materials').then(({ data }) => {
                commit(types.STORE_UNDER_LIMIT_MATERIALS, data)
            })
        },

        // update single transaction 
        updateSingleTransaction ({ commit }, { id, materialId, accountId, out, inAmount, notes, date, sellPrice, state, freeSample, priceDiscount }) {
            return window.axios.put(`/materialtransactions/singleTransaction/${id}`, {
                id,
                materialId, 
                accountId, 
                out, 
                in: inAmount, 
                notes, 
                date, 
                sellPrice, 
                state,
                // new
                freeSample,
                priceDiscount
            }).then(({ data }) => {
                return data
            })
        },

        deleteSingleTransaction({ commit }, { id }) {
            return window.axios.delete(`/materialTransactions/singleTransaction/${id}`)
        },

        // team planned transaction
        createTeamPlanned ({ commit }, { accountId, inAmount, materialId, date, description }) {
            return window.axios.post('/materialTransactions/TeamPlannedTransaction', {
                accountId,
                inAmount,
                materialId,
                date,
                description
            }).then((data) => {
                return data
            })
        },

        getTeamPlanned ({ commit }, { id }) {
            return window.axios.get('/materialTransactions/TeamPlannedTransaction', { params: { id } }).then((data) => {
                return data
            })
        },

        updateTeamPlanned ({ commit }, { accountId, inAmount, materialId, date, description, id }) {
            return window.axios.put(`/materialTransactions/TeamPlannedTransaction/${id}`, {
                accountId,
                inAmount,
                materialId,
                date,
                description
            }).then((data) => {
                return data
            })
        },

        deleteTeamPlanned ({ commit }, { id }) {
            return window.axios.delete(`/materialTransactions/TeamPlannedTransaction/${id}`).then((data) => {
                return data
            })
        },

        getTeamPlannedTransactionForMonth ({ commit }, { date, teamId }) {
            return window.axios.get('materialTransactions/TeamPlannedTransactionForMonth', { 
                params: {
                    date, 
                    teamId
                }
            })
        },

        executeTeamPlannedTransaction ({ commit }, { id }) {
            return window.axios.post('materialTransactions/executeTeamPlannedTransaction', id, { headers: { 'Content-Type': 'application/json' } }).then(({ data }) => {
                return data
            })
        }
    },

    mutations:{
        // [types.STORE_SUMMARY](state, summary){
        //     state.summary = summary;
        // },

        [types.STORE_TRANSACTINOS](state, transactions){
            state.transactions = transactions;
        },
        
        [types.STORE_TRANSACTIONS_STATEMENT](state, transactionsStatement){
            state.transactionsStatement = transactionsStatement;
        },

        [types.STORE_UNDER_LIMIT_MATERIALS] (state, underLimitMaterials) {
            state.underLimitMaterials = underLimitMaterials
        },
    },

    getters:{
        getTransactionById: state => id => state.transactions.find(c => c.id === id),
    }
}